<ng-container *ngFor="let plan of planList">
  <div class="pricing-container">
    <div class="plan-header">
      <span>{{plan.planType}}</span>
      <span>{{plan.planDetails}}</span>
    </div>
    <mat-divider></mat-divider>
    <div class="plan-container-body">
      <app-button [button]="selectPlanButton">
      </app-button>
    </div>
    <div class="plan-details">
      <span>{{plan.validity}}</span>
      <br>
      <span>{{plan.limit}}</span>
      <br *ngIf="plan.freePlan">
      <span *ngIf="plan.freePlan">{{plan.freePlan}}</span>
      <br>
      <span *ngIf="plan.cost">{{plan.cost}}</span>
    </div>
  </div>
</ng-container>
